import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Tooltip} from 'react-tooltip';

import {useInput, useRemoveField, useToggleRequired} from '../../model';

import {
  setFields,
  deleteOption,
  addOption,
} from '../../service/createForm.slice';

import {Input, RemoveButton, RequiredButton} from '../../ui';
import {
  AcceptableIcon,
  CloseIcon,
  CommentIcon,
  RadioIcon,
  SelectIcon,
} from '../../icons';

import {RADIO_OPTION, SELECT_OPTION} from '../staticData';
import {useLocation} from 'react-router-dom';
import {useTranslation} from '../../../../hooks/useTranslation';
function SelectField({field, idx}) {
  const dispatch = useDispatch();
  const radioField = useSelector(
    state => state.rootReducer?.createFormSlice?.data,
  );
  const location = useLocation();
  let isReadOnly = Boolean(location.search.split('=')[1]);
  const {t} = useTranslation();
  const {toggleRequired} = useToggleRequired();
  const {removeField} = useRemoveField();
  const form_title = useInput('');

  const handleRequired = () => toggleRequired(idx);

  const handleChange = e => {
    form_title.handleChange(e);
    dispatch(
      setFields({
        index: idx,
        key: 'label',
        value: e.target.value,
      }),
    );
  };

  const handleOptionLabel = (e, index) => {
    dispatch(
      setFields({
        parentIndex: idx,
        nestingKey: 'options',
        index,
        value: e.target.value,
        key: 'label',
      }),
    );
  };

  const handleStatus = (key, index, value) => {
    dispatch(
      setFields({
        parentIndex: idx,
        nestingKey: 'options',
        value: value,
        index,
        key,
      }),
    );
  };

  const handleRemoveOption = (key, index) => {
    dispatch(
      deleteOption({
        parentIndex: idx,
        key,
        index,
      }),
    );
  };

  const handleAddOption = () => {
    dispatch(
      addOption({
        parentIndex: idx,
        option: SELECT_OPTION,
        key: 'options',
      }),
    );
  };

  const handleRemove = () => removeField(idx);

  return (
    <div className='f-build__general'>
      <div className='f-build__general-header'>
        <Input
          onChange={handleChange}
          label={t('createNewForm.components.fieldName')}
          placeholder={t('createNewForm.components.enterFieldName')}
          value={field?.label}
          disabled={isReadOnly}
        />
        {!isReadOnly && (
          <div className='f-build__general-actions'>
            <RequiredButton
              key={'input-required'}
              idx={idx}
              id={'input-required'}
              required={field?.required}
              handleRequired={handleRequired}
            />
            <RemoveButton
              key={'radio-remove'}
              idx={idx}
              id={'radio'}
              handleRemove={handleRemove}
            />
          </div>
        )}
      </div>
      <div className='f-build__general-type'>
        <SelectIcon />
        <span>{t('createNewForm.components.dropdown')}</span>
      </div>
      <div className='f-build__general-options'>
        {field?.options?.map((option, index) => (
          <div className='f-build__general-option' key={index}>
            <Input
              disabled={isReadOnly}
              value={option?.label}
              placeholder={`${t('createNewForm.components.option')} ${index + 1}`}
              key={`input-${idx}-${index}`}
              onChange={e => handleOptionLabel(e, index)}
            />
            {!isReadOnly && (
              <>
                <div
                  className='f-build__general-icon'
                  onClick={() =>
                    handleStatus('acceptable', index, !option?.acceptable)
                  }
                  data-tooltip-id={`acceptable-select-${idx}-${index}`}
                  data-tooltip-content={t('createNewForm.components.acceptable')}
                >
                  <AcceptableIcon active={option?.acceptable} />
                  <Tooltip
                    id={`acceptable-select-${idx}-${index}`}
                    place={'top-end'}
                  />
                </div>
                <div
                  className='f-build__general-icon'
                  onClick={() =>
                    handleStatus('has_comment', index, !option?.has_comment)
                  }
                  data-tooltip-id={`comment-select-${idx}-${index}`}
                  data-tooltip-content={t('createNewForm.components.comment')}
                >
                  <CommentIcon active={option?.has_comment} />
                  <Tooltip
                    id={`comment-select-${idx}-${index}`}
                    place={'top-end'}
                  />
                </div>
              </>
            )}
            {field?.options?.length > 1 && !isReadOnly ? (
              <div
                className='f-build__general-icon close'
                onClick={() => handleRemoveOption('options', index)}
                data-tooltip-id={`remove-select-${idx}-${index}`}
                data-tooltip-content={t('createNewForm.components.remove')}
              >
                <CloseIcon />
                <Tooltip
                  id={`remove-select-${idx}-${index}`}
                  place={'top-end'}
                />
              </div>
            ) : null}
          </div>
        ))}
        {!isReadOnly && (
          <div onClick={handleAddOption} className='f-build__option_add'>
            {t('createNewForm.components.addOption')}
          </div>
        )}
      </div>
    </div>
  );
}

export default SelectField;
